/**
 * Determine if the user has interacted with My Wallet
 * @returns bool
 */
export default (win) => {
	const CAIWalletConfigValue =
		window.localStorage?.getItem('CAIWalletConfig');
	const optOut = win.DDC.getSiteProperty('OptOutCAIWalletConfig');
	if (!optOut && CAIWalletConfigValue) {
		const CAIWalletConfig = JSON.parse(CAIWalletConfigValue);
		if (CAIWalletConfig && CAIWalletConfig.interactions) {
			return (
				CAIWalletConfig.interactions.hasUpdatedWallet ||
				CAIWalletConfig.interactions.hasOpenedWallet
			);
		}
	}
	return false;
};
